import { quickAccess } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function QuickAccess() {
  return (
    <section id="overview" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          eyebrow="内容速览"
          title="一页看懂：这里都有哪些衍生内容"
          desc="按类别分区整理，每一区都给出具体的条目与阅读方向。先看这一屏，再决定从哪一块深入。"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {quickAccess.map((item, index) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`group flex flex-col rounded-lg border p-5 md:p-6 transition-all hover:-translate-y-1 ${
                index === 0
                  ? "border-primary-200 bg-primary-50"
                  : index === 4
                    ? "border-accent-200 bg-accent-50"
                    : "border-background-200 bg-background-100"
              }`}
            >
              <div className="flex items-center justify-between">
                <span
                  className={`w-11 h-11 flex items-center justify-center rounded-md text-xl ${
                    index === 0
                      ? "bg-primary-500 text-background-50"
                      : index === 4
                        ? "bg-accent-500 text-secondary-950"
                        : "bg-secondary-100 text-secondary-900"
                  }`}
                >
                  <i className={item.icon}></i>
                </span>
                <span className="text-xs text-foreground-500">{item.count}</span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 flex-1">{item.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                进入分区
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}